import { jsx as _jsx } from "preact/jsx-runtime";
// @ts-ignore
import { createRootFragment } from "preact-root-fragment";
import { render } from "preact";
import { useEffect, useRef } from "preact/hooks";
const BlurCanvas = (props) => {
    const canvasRef = useRef(null);
    useEffect(() => {
        if (!canvasRef.current)
            return;
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        const image = new Image();
        image.src = props.img.src;
        const totalWidth = image.width + props.rad * 2;
        const totalHeight = image.height + props.rad * 2;
        canvas.width = totalWidth;
        canvas.height = totalHeight;
        canvas.style.width = `${image.width}px`;
        canvas.style.height = `${image.height}px`;
        image.onload = function () {
            if (!canvas || !ctx)
                return;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.filter = `blur(${props.rad}px)`;
            ctx.drawImage(image, props.rad, props.rad, image.width, image.height);
        };
    }, [props.img, props.rad]);
    return _jsx("canvas", { ref: canvasRef });
};
function addBlur(el) {
    const blurRad = el.dataset.blur;
    const parsedRad = parseInt(blurRad);
    const wrapElement = (element) => {
        var _a;
        const container = document.createElement("div");
        container.classList.add("soul-blur-container");
        (_a = element.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(container, element);
        container.appendChild(element);
        const target = document.createElement("div");
        container.appendChild(target);
        return [container, target];
    };
    const [container, target] = wrapElement(el);
    render(_jsx(BlurCanvas, { img: el, rad: parsedRad }), createRootFragment(container, target));
    el.style.opacity = "0";
}
function autoAddBlurs() {
    const blurElements = document.querySelectorAll("[data-blur]");
    blurElements.forEach(addBlur);
}
export default autoAddBlurs;
